<template>
  <div
    :class="{ friendly: friendly }"
    class="representative-photo-container">
    <picture>
      <source :srcset="photoUrl + '.webp'" type="image/webp">
      <source :srcset="photoUrl + '.jpg'" type="image/jpeg">
      <img :src="photoUrl + '.jpg'" :alt="alt">
    </picture>
    <div class="representative-photo-symbol">
      <span v-if="friendly" class="symbol symbol-done"> ✓ </span>
      <img v-if="!friendly" class="symbol symbol-phone" src="/static/img/phone.svg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'RepresentativePhoto',
  props: {
    photoUrl: String,
    friendly: Boolean,
    alt: String,
  },
}
</script>

<style lang=scss scoped>
@import '@/assets/styles/_variable.scss';

.representative-photo-container {
  display: flex;
  position: relative;
  border: 0.2em solid $dark-red;

  &.friendly {
    border-color: $friendly-green;
  }

  .symbol {
    height: 1em;
    width: auto;
    display: inline;
    fill: #fff;
    background: none !important;
  }
  picture {
    width: 170px;
    height: 215px;
    background-color: #eee;
    filter: grayscale(100%);
  }

  &.friendly picture {
    filter: none;
  }

  .representative-photo-symbol {
    position: absolute;
    color: white;
    background: linear-gradient(to right bottom, transparent 50%, $dark-red 50%);
    width: 2.2em;
    height: 2.2em;
    padding-top: 0.9em;
    padding-left: 0.9em;
    right: 0;
    bottom: 0;
    text-align: center;
  }
  &.friendly .representative-photo-symbol {
    background: linear-gradient(to right bottom, transparent 50%, $friendly-green 50%);
  }
}
</style>
